/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CsvTxCardFields/view.blocks to change it.
import Definitions from './Definitions/index'
import Options from './Options/index'
import React from 'react'
import SetupAction from './SetupAction/index'
import Types from './Types/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CsvTxCardFields({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Onboarding/CsvTxCardFields"
  
}) {
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Tx card fields"
/>
<div
  data-testid="CsvTxCardFields.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Types
  viewPath={`${viewPath}/Types`}
/>
<Options
  viewPath={`${viewPath}/Options`}
/>
<Definitions
  viewPath={`${viewPath}/Definitions`}
/>
</div>
<SetupAction
  viewPath={`${viewPath}/SetupAction`}
/>
{children}
</React.Fragment>)
}